import { mString, pluralize } from 'lib/helpers/utility';

import { generateDayEventOptions, generateOnEventOptions } from '../../../lib/helpers';

import InfoBox from './InfoBox';

const AutoRecurringInfo = ({ recurringPayment, totalAmount }) => {
  const { repeatEvent, repeatEvery, chargeTime, onEvent, dayEvent } = recurringPayment;

  if (!totalAmount) return null;

  const onEventLabel = generateOnEventOptions(repeatEvent).find((o) => o.value === onEvent)?.label;
  const dayEventLabel = generateDayEventOptions(onEvent).find((o) => o.value === dayEvent)?.label;

  let schedule;

  if (repeatEvent === 'weekly') {
    const weekLabel = repeatEvery > 1 ? `${repeatEvery} ${pluralize('week', repeatEvery)}` : 'week';
    schedule = (
      <>
        every <span className="whitespace-nowrap font-semibold">{weekLabel}</span> on{' '}
        <span className="whitespace-nowrap font-semibold">{onEventLabel}</span>
      </>
    );
  } else if (repeatEvent === 'yearly') {
    const yearLabel = repeatEvery > 1 ? `${repeatEvery} ${pluralize('year', repeatEvery)}` : 'year';

    schedule = (
      <>
        every <span className="whitespace-nowrap font-semibold">{yearLabel}</span> on the{' '}
        <span className="whitespace-nowrap font-semibold">
          {onEventLabel} {dayEventLabel}
        </span>
      </>
    );
  } else if (chargeTime === 'immediately') {
    schedule = (
      <>
        on the{' '}
        <span className="whitespace-nowrap font-semibold">{dayEventLabel} day of the month</span>,
        starting <span className="whitespace-nowrap font-semibold">Today</span>
      </>
    );
  } else {
    const monthLabel =
      repeatEvery > 1 ? `${repeatEvery} ${pluralize('month', repeatEvery)}` : 'month';
    schedule = (
      <>
        every <span className="whitespace-nowrap font-semibold">{monthLabel}</span> on the{' '}
        <span className="whitespace-nowrap font-semibold">{dayEventLabel}</span>
      </>
    );
  }

  return (
    <InfoBox>
      Your recurring payment will be charged for{' '}
      <span className="whitespace-nowrap font-semibold">{mString(totalAmount)}</span> {schedule}.
    </InfoBox>
  );
};

export default AutoRecurringInfo;
